export const parseFirstName = (fullName: string) => {
    const splitName = fullName.split(' ');
    if (splitName.length === 1) {
        return fullName;
    }
    // Ex: Reid Hiatt => Reid
    // Ex: Juan Manuel Sanchez => Juan Manuel
    // Broken Ex: Juan Manuel Sanchez Ramirez => Juan Manuel Sanchez
    return splitName.slice(0, -1).join(' ');
};
